<template>
  <div>
    <!--タイトル-->
    <header id="header">
      <Header title-image="static/images/common/logo-practice.svg" can-back-flag="1"></Header>
    </header>

    <!--一覧-->
    <div id="wrapper">
      <div class="content">
        <section v-if='chapter.length != 0'>
          <h3 class="ttl">{{ chapter[0].part }}{{ chapter[0].chapter }}（章全体 {{ chapter[0].time_all }}）</h3>
          <article>
            <ul>
              <li v-for='row in chapter' v-bind:key='row.id'>
                <a href="#" v-on:click.prevent='linkAction' :data-id='row.id' :data-count='chapter[0].question_count'>問{{ row.question_num }}（{{ row.time }}）</a>
              </li>
            </ul>
          </article>
        </section>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/modules/Header'
import cmd from '@/common/Command'

export default {
  mounted: function () {
    $("body").removeClass()
    $("body").addClass("page-low")
    $("body").addClass("cat-practice")
    $("body").addClass("page-practice-chapter")
    cmd.adjustStyle()

    if ( this.chapter.length == 0 ) {
      this.returnToIndex()
    }
  },
  methods: {
    ...mapActions('PracticeModule', {
      'prevAction': 'prevAction',
      'showDetail': 'showDetail',
      'returnToIndex': 'returnToIndex',
    }),
    linkAction (e) {
      var element = e.currentTarget
      var id = element.getAttribute('data-id')
      var count = element.getAttribute('data-count')
      this.showDetail([id, count])
    }

  },
  computed: {
    ...mapGetters('PracticeModule', {
      'chapter': 'getChapter',
    }),
  },
  components: {
    Header
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PracticeChapter.vue